export default __webpack_public_path__ + "assets/payment.37178236.svg";